import React, { Component } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Menu, Icon, MenuItemProps, LabelProps } from 'semantic-ui-react';
import userManager from '../userManager';
import MenuUser from './MenuUser';
import { ApplicationState } from '../..';
import * as Core from '../../core';

type OwnProps = {
    onMenuClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, data: MenuItemProps) => void
}

const connector = connect(
    (state: ApplicationState) => ({
        logo: state.core.auth.user!.profile.picture,
    }),
    Core.actions,
)
type PropsFromRedux = ConnectedProps<typeof connector>

type PrincipaleHeaderMobileProps = 
    PropsFromRedux &
    OwnProps

class PrincipaleHeaderMobile extends Component<PrincipaleHeaderMobileProps> {
    constructor(props: PrincipaleHeaderMobileProps) {
        super(props);
      
        this.onLogout = this.onLogout.bind(this);
        this.onLinguaClick = this.onLinguaClick.bind(this);
    }

    render () {
      const { logo } = this.props;

      return (
            <Menu attached='top' inverted color='grey'>
                <Menu.Item onClick={this.props.onMenuClick}><Icon name='bars' /></Menu.Item>
                <Menu.Item>
                    <img src={logo} alt="logo" />
                </Menu.Item>
                <MenuUser onLinguaClick={this.onLinguaClick} onLogout={this.onLogout} />
            </Menu>
        );
    }

    onLogout() {
        userManager.signoutRedirect();
    }

    onLinguaClick(_: React.MouseEvent<HTMLElement, MouseEvent>, data: LabelProps) {
        this.props.cambiaLingua(data.lingua);
    }
}

export default connector(PrincipaleHeaderMobile);
